(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function decimals(str) {
    if (str == null || str === '') return 0;
    var s = String(str);
    var i = s.indexOf('.');
    return i < 0 ? 0 : s.length - i - 1;
  }

  function parseNum(str) {
    var n = parseFloat(String(str || '').replace(/,/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function format(n, dec) {
    if (dec <= 0) return String(Math.round(n));
    return n.toFixed(dec);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function runCounter(el) {
    if (el.getAttribute('data-gutzy-stat-done') === '1') return;
    var target = parseNum(el.dataset.target);
    var duration = parseInt(el.dataset.duration || '2000', 10) || 2000;
    var down = el.dataset.direction === 'down';
    var from;
    if (el.dataset.from !== undefined && el.dataset.from !== '') {
      from = parseNum(el.dataset.from);
      if (isNaN(from)) from = down ? target + 100 : 0;
    } else {
      from = down ? target + Math.max(50, Math.abs(target) * 0.25) : 0;
    }
    if (down) {
      if (from <= target) from = target + Math.max(50, Math.abs(target) * 0.25);
    } else {
      if (from > target) from = 0;
    }
    var dec = Math.max(decimals(el.dataset.target), decimals(el.dataset.from));
    el.textContent = format(from, dec);
    var t0 = null;
    function step(now) {
      if (t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / duration);
      var k = easeOutCubic(p);
      var val = from + (target - from) * k;
      el.textContent = format(val, dec);
      if (p < 1) requestAnimationFrame(step);
      else {
        el.textContent = format(target, dec);
        el.setAttribute('data-gutzy-stat-done', '1');
      }
    }
    requestAnimationFrame(step);
  }

  function init() {
    var counters = document.querySelectorAll('[data-gutzy-stat-counter]');
    if (!counters.length) return;

    var started = false;
    function startAll() {
      if (started) return;
      started = true;
      counters.forEach(runCounter);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var hit = false;
          entries.forEach(function (e) {
            if (e.isIntersecting) hit = true;
          });
          if (hit) {
            io.disconnect();
            startAll();
          }
        },
        { rootMargin: '40px 0px 0px 0px', threshold: 0 }
      );
      counters.forEach(function (el) {
        io.observe(el);
      });
      window.setTimeout(function () {
        startAll();
        try {
          io.disconnect();
        } catch (_) {}
      }, 3000);
    } else {
      startAll();
    }
  }

  onReady(init);
})();
